import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { ContentService } from "../services/content.service";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

export const consentSignedGuard: CanActivateFn = (route, state) => {
  const contentService = inject(ContentService);
  const router = inject(Router);

  return contentService.getContract().pipe(
    map((contract: any) => {
      if (contract && contract.status === 'contract-signed') {
        if (state.url.includes('/questionnaire/postcomprehensive')) {
          return router.parseUrl('/journey');
        }
        if (state.url.includes('/journey')) {
          return true;
        }
        return true;
      } else {
        if (state.url.includes('/journey')) {
          return router.parseUrl('/questionnaire/postcomprehensive');
        }
        return true;
      }
    }),
    catchError(() => {
      // On error, redirect to postcomprehensive if trying to access journey
      if (state.url.includes('/journey')) {
        return of(router.parseUrl('/questionnaire/postcomprehensive'));
      }
      return of(true);
    })
  );
}; 